import { uniqBy } from 'lodash';

import * as types from './constants';

export const initialState = {
  dataTable: [],
  loading: false,
  loaded: false,
  query: null,
  message: null,
  count: 0,
  next: null,
  previous: null,
  page_url: null,
  errors_api: {}
};

const actions = {
  // Get Shopify Collections
  [types.GET_SHOPIFY_COLLECTIONS_REQUEST]: (state, { payload }) => {
    const data = {
      ...state,
      loading: true,
      errors_api: {},
      ...(!payload?.pageUrl && { loaded: false, query: payload?.searchQ || '' })
    };

    return { ...data };
  },

  // A follow-up page (`append`) extends the list, a first page replaces it.
  [types.GET_SHOPIFY_COLLECTIONS_DONE]: (state, { payload: { append, ...payload } }) => {
    const data = {
      ...state,
      ...payload,
      dataTable: append ? uniqBy([...state.dataTable, ...payload.dataTable], 'id') : payload.dataTable,
      loading: false,
      loaded: true
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_COLLECTIONS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_COLLECTIONS_RESET]: () => {
    return { ...initialState };
  },

  // Operations
  [types.SHOPIFY_COLLECTIONS_SET_PAGE_URL]: (state, { payload }) => {
    const data = {
      ...state,
      page_url: payload || null
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
